var _displayAcquisitionPopupContainerQuery;
import { useEffect, useMemo } from "react";
import { graphql, usePreloadedQuery } from "react-relay";
import { PopupContentType } from "~/components/acquisition-popup-container/types";
import { useSdkContext } from "~/components/contexts";
import { gtag } from "~/lib/gtag";
import { useAcquisitionPopup } from "./hooks";
import { useRenderPopup } from "./popup-render-hooks";
import { useAcquisitionNewsletterPopupGetter } from "./popups/acquisition-newsletter/hooks";
import { useCampaignPopupGetter } from "./popups/campaign/hooks";
import { useMyNewsCompletionPopupGetter } from "./popups/my-news/completion/hooks";
import { useTopicPackageFollowPopupGetter } from "./popups/topic-package-follow/hooks";
import { useWhyRegisterPopupGetter } from "./popups/why-register/hooks";
export const AcquisitionPopupContainerDisplay = ({
  configEnvironmentSlug,
  queryReference,
  ...renderPopupOptions
}) => {
  var _popup$element;
  const {
    currentRouteWithoutQuerystring
  } = useSdkContext();
  const data = usePreloadedQuery(query, queryReference);
  useAcquisitionPopup({
    configEnvironmentSlug
  }, data);
  useEffect(() => {
    if (currentRouteWithoutQuerystring) gtag("event", "optimize.triggerCampaign");
  }, [currentRouteWithoutQuerystring]);
  const campaignPopupGetter = useCampaignPopupGetter(renderPopupOptions);
  const acquisitionNewsletterPopupGetter = useAcquisitionNewsletterPopupGetter(renderPopupOptions);
  const whyRegisterPopupGetter = useWhyRegisterPopupGetter(renderPopupOptions);
  const topicPackageFollowPopupGetter = useTopicPackageFollowPopupGetter(renderPopupOptions);

  // My news
  const myNewsCompletionPopupGetter = useMyNewsCompletionPopupGetter(renderPopupOptions);

  /**
   * the following is mapping of each popup
   * the render function will loop for each key for popup content until the first non-undefined content
   * or return empty fragment if no more popup content is found
   */
  const popupGetters = useMemo(() => ({
    [PopupContentType.WhyRegister]: whyRegisterPopupGetter,
    [PopupContentType.MyNewsCompletion]: myNewsCompletionPopupGetter,
    [PopupContentType.TopicPackageFollow]: topicPackageFollowPopupGetter,
    [PopupContentType.Campaign]: campaignPopupGetter,
    [PopupContentType.AcquisitionNewsletter]: acquisitionNewsletterPopupGetter
  }), [acquisitionNewsletterPopupGetter, campaignPopupGetter, myNewsCompletionPopupGetter, topicPackageFollowPopupGetter, whyRegisterPopupGetter]);
  const {
    popup
  } = useRenderPopup(popupGetters, renderPopupOptions);
  return (_popup$element = popup === null || popup === void 0 ? void 0 : popup.element) !== null && _popup$element !== void 0 ? _popup$element : null;
};
AcquisitionPopupContainerDisplay.displayName = "AcquisitionPopupContainerDisplay";
export const query = _displayAcquisitionPopupContainerQuery !== void 0 ? _displayAcquisitionPopupContainerQuery : (_displayAcquisitionPopupContainerQuery = require("../../../queries/__generated__/displayAcquisitionPopupContainerQuery.graphql"), _displayAcquisitionPopupContainerQuery.hash && _displayAcquisitionPopupContainerQuery.hash !== "3ff4df315a1765e4d99b01b77df32294" && console.error("The definition of 'displayAcquisitionPopupContainerQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _displayAcquisitionPopupContainerQuery);